module.exports = __webpack_public_path__ + "img/powerpoint.627900b8.svg";